import { Input } from "@/components/ui/input";

export function RecommendedFields({ fields, attributes, onChange }) {
  if (!fields.length) return null;
  return (
    <div className="rounded-md border border-[#D97706]/25 bg-[#D97706]/5 p-4" data-testid="recommended-fields">
      <div className="lf-label mb-3 text-[#F59E0B]">Recommended for this category</div>
      <div className="grid gap-x-4 gap-y-2.5 sm:grid-cols-2">
        {fields.map((f) => (
          <label key={f.key} className="grid items-center gap-1 text-sm sm:grid-cols-[130px_1fr] sm:gap-2">
            <span className="text-[#A8A090] truncate" title={f.label}>{f.label}{f.optional && <span className="opacity-60"> · opt.</span>}</span>
            <Input className="h-9" value={attributes[f.key] || ""} onChange={(e) => onChange({ ...attributes, [f.key]: e.target.value })}
              placeholder={f.optional ? "If it applies" : "Not set"} data-testid={`recommended-field-${f.key}`} />
          </label>
        ))}
      </div>
    </div>
  );
}
